

export default {
  name: 'CDivider'
}
